import { VirtualAccount } from '@/DTOs/virtualAccount';

/**
 * Extracts the account nickname (suffix) from receiverName.
 * CRB constructs receiverName as "BeneficiaryName_Suffix".
 * Returns the suffix portion, or the full receiverName if no separator found.
 */
export const getAccountNickname = (
  virtualAccount: VirtualAccount,
  beneficiaryName?: string,
): string => {
  const receiverName = virtualAccount.receiverName ?? '';

  if (beneficiaryName && receiverName.startsWith(beneficiaryName)) {
    const remainder = receiverName.slice(beneficiaryName.length);
    if (remainder.startsWith('_') && remainder.length > 1) {
      return remainder.slice(1);
    }
    if (remainder === '') {
      return receiverName;
    }
  }

  return receiverName;
};
